import type { IconProps } from './types';

function Building06Icon(props: IconProps) {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M6.84375 5.90625V7.78125M6.84375 9.65625V11.5312M6.84375 13.4062V15.2812M11.5312 9.65625V11.5312M11.5312 5.90625V7.78125M11.5312 13.4062V15.2812M15.75 21.375H21.375V10.125H15.75V21.375ZM15.75 21.375V2.625H2.625V21.375H15.75ZM9.1875 17.625V21.375"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { Building06Icon };
